<div class="drugs-by-indication-container">
  <div class="header">
    <div class="chart-title">
      <span>Indication</span>
    </div>
    <div class="chart-info">
      <span
        ># of Drugs<span *ngIf="totalCount > 10">
          | Displaying 10 out of {{ totalCount }} Indications</span
        ></span
      >
    </div>
  </div>
  <div class="chart-container">
    <nz-spin nzTip="Crunching numbers..." *ngIf="!chartReady" class="spinner">
    </nz-spin>
    <highcharts-chart
      *ngIf="chartReady && !showError"
      [Highcharts]="highcharts"
      [options]="chartIndicationOptions"
      [(update)]="updateIndicationFlag"
      style="width: 100%; height: 100%;display: block;"
      ngClass="indication"
    >
    </highcharts-chart>
    <div id="charts-error" class="error-container" *ngIf="showError">
      <div class="error-msg">
        <va-icon name="info-circle" class="info-icon"></va-icon>
        <span class="error-text">{{
          errorMessage ? errorMessage : "Something went wrong!"
        }}</span>
      </div>
    </div>
  </div>
  <div class="rank-info">
    <div
      *ngIf="
        chartReady &&
        selectedRank > 10 &&
        selectedIndication === chartFilters.indication
      "
    >
        <va-icon name="info-circle" class="info-icon"></va-icon>
      <span>Selected indication's actual rank is {{ selectedRank }}</span>
    </div>
  </div>
</div>
